
import React, { BaseSyntheticEvent, ReactNode } from 'react';
import { CQAppConstant } from '../../../../app-constants';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { observer } from 'mobx-react';
import { RuleEngineController } from '../ruleEngine.Controller';
import { IApplyRuleModalProps, IApplyRuleModalState } from '../ILayoutConfigurationPanel.Interface';
import { SelectRuleTypeDropDown } from './select-rule-type.component';
import { AppliedRuleTextPreview } from './applied-rule-preview-textarea';
import { ToggleActionRulesModal } from './rule-components/toggle-actions-modal.component';
import { Utility } from '../../../../common/utility';
import { LookupFilterRule } from './rule-components/lookup-filter.component';
import { FormulaFieldsModal } from './rule-components/formula-fields.component';
import { DynamicSourceModal } from './rule-components/dynamic-source.component';
import { TransferRuleModal } from './rule-components/transfer-rule.component';
import { SetValuesRulesModal } from './rule-components/set-values.component';
import { InvokeActionsRulesModal } from './rule-components/invoke-action.component';
import { OnInitInvokeActionsRulesModal } from './rule-components/onInit-invoke.component';
import { OnLoadSetValuesRulesModal } from './rule-components/onload-set-values.component';
import { OnInitSetValuesActionsRulesModal } from './rule-components/oninit-set-values.component';
import { OnLoadInvokeRulesModal } from './rule-components/onload-invoke.component';
import { OnLoadTransferRulesModal } from './rule-components/onLoad-transfer.component';
import { AfterSaveRedirectToRulesModal } from './rule-components/aftersave-redirectto.component';

import './apply-rule-modal.css';
import TemplateConfigurationController from '../../template-config.controller';

class ApplyRuleModalComponent extends React.Component<IApplyRuleModalProps, IApplyRuleModalState> {
    private readonly ruleEngineController: RuleEngineController;
    private cqUtilityClass: Utility;
    private templateConfigCtrl: TemplateConfigurationController;
    constructor(props: Readonly<IApplyRuleModalProps>) {
        super(props);
        this.cqUtilityClass = new Utility();
        const fieldData = CQMasterDataStore.Details.selectedFieldDetailsObject;
        let applicableRules = CQAppConstant.RULE_TYPES_OBJECT[(fieldData.type).toUpperCase()];
        let selectedRuleType =  (applicableRules && applicableRules.length)===1?applicableRules[0]:'';
        this.state = {
            selectedRuleType: selectedRuleType,
            fieldData: fieldData,
            ruleJSON: '',
            ruleObject: {},
            isFormValid: true
            // additionalFields: {}
        };
        this.ruleEngineController = new RuleEngineController();
        this.templateConfigCtrl = new TemplateConfigurationController();
    }

    componentDidMount() {
        
        if (this.props.appliedRule) {
            this.setState({
                selectedRuleType: this.props.appliedRule
            });
            if (this.props.appliedRule !== 'setValues' && this.props.appliedRule !== 'invoke'
                && this.props.appliedRule !== 'onInit-invoke' && this.props.appliedRule !== 'onLoad-setValues') {
                this.setState({
                    selectedRuleType:
                        this.props.appliedRule === 'lookup filter' ? CQAppConstant.CQ_RECORD_RULES_TYPES.lookupFilter.key :
                            this.props.appliedRule
                });
            }
        }
    }

    public render(): ReactNode {
        return (
            <>
                <section role="dialog" className="slds-modal slds-fade-in-open slds-modal_small">
                    <div className="slds-modal__container">
                        <header className="slds-modal__header">
                            <h2 className="slds-text-heading_medium slds-hyphenate">{'Add Rule'} {this.state.selectedRuleType ? `(${this.state.selectedRuleType})` : ''}</h2>
                            {
                                this.state.fieldData &&
                                <p>{this.state.fieldData.label} ({this.state.fieldData.fullName})</p>
                            }
                        </header>
                        <div className="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
                            <div className="slds-grid slds-grid_vertical">
                                {<SelectRuleTypeDropDown editOnly={this.props.appliedRule}
                                    onComponentRuleTypeChanged={this.onComponentRuleTypeChanged}
                                    onRuleTypeChanged={this.onRuleTypeChanged} appliedRule={this.state.selectedRuleType} fieldData={this.state.fieldData} selectedTemplateName={this.props.selectedTemplateName} />
                            }
                                {
                                    this.viewAsPerRule()
                                }
                            </div>
                            <AppliedRuleTextPreview isFormValid={this.state.isFormValid} appliedRuleJSON={this.state.ruleJSON} />
                        </div>
                        <footer className="slds-modal__footer">
                            <button className="slds-button slds-button_neutral" onClick={() => this.props.toggleModalVisibility()}>Cancel</button>
                            <button disabled={this.state.isFormValid}
                                className="slds-button slds-button_brand" onClick={() => this.previewInputRuleJSON()}>Preview</button>
                            <button disabled={this.state.isFormValid}
                                className="slds-button slds-button_brand" onClick={() => this.formRuleJson()}>Save</button>
                        </footer>
                    </div>
                </section>
                <div className="slds-backdrop slds-backdrop_open"></div>
            </>
        );
    }

    /**
     * @memberof ApplyRuleModalComponent
     */
    public checkValidation = (isFormValid: boolean) => {
        this.setState({
            isFormValid
        });
    }

    /**
     * @memberof ApplyRuleModalComponent
     */
    public setRuleObject = (ruleObject: any) => {
        this.setState({
            ruleObject
        });
    }


    /**
     * @private
     * @memberof ApplyRuleModalComponent
     */
    private onRuleTypeChanged = (e: BaseSyntheticEvent) => {
        this.setState({ selectedRuleType: e.target.value, ruleJSON: '' });
    }

    /**
     * @private
     * @memberof ApplyRuleModalComponent
     */
    private onComponentRuleTypeChanged = (componentRule: string) => {
        this.setState({ selectedRuleType: componentRule, ruleJSON: '' });
    }


    /**
     * @private
     * @memberof ApplyRuleModalComponent
     */
    private readonly viewAsPerRule = () => {
        const isToggleView = CQAppConstant.TOGGLE_ACTION_RULES.includes(this.state.selectedRuleType);
        if (isToggleView) {
            return <ToggleActionRulesModal
                objectName={this.state.fieldData.fullName} appliedRule={this.props.appliedRule}
                checkValidation={this.checkValidation}
                setRuleObject={this.setRuleObject} selectedTemplateName={this.props.selectedTemplateName}
                toggleModalVisibility={this.props.toggleModalVisibility} ruleObject={this.state.ruleObject}
            />;
        } else if (this.state.selectedRuleType === 'lookupFilter') {
            return <LookupFilterRule
                objectName={this.state.fieldData.fullName}
                referenceTo={this.state.fieldData.referenceTo}
                appliedRule={this.props.appliedRule}
                checkValidation={this.checkValidation}
                setRuleObject={this.setRuleObject} selectedTemplateName={this.props.selectedTemplateName}
                toggleModalVisibility={this.props.toggleModalVisibility} ruleObject={this.state.ruleObject} />;
        } else if (this.state.selectedRuleType === 'Formula Field - Hyperlink' || this.state.selectedRuleType === 'Formula Field - Image') {
            return <FormulaFieldsModal
                objectName={this.state.fieldData.fullName} appliedRule={this.props.appliedRule}
                selectedFormulaType={this.getFormulaFieldType()}
                checkValidation={this.checkValidation}
                setRuleObject={this.setRuleObject} selectedTemplateName={this.props.selectedTemplateName}
                toggleModalVisibility={this.props.toggleModalVisibility} ruleObject={this.state.ruleObject} />;
        } else if (this.state.selectedRuleType === CQAppConstant.DYNAMIC_SOURCE) {
            return <DynamicSourceModal
                appliedRule={this.props.appliedRule}
                selectedTemplateName={this.props.selectedTemplateName}
                objectName={this.state.fieldData.fullName}
                selectedFormulaType={this.getFormulaFieldType()}
                checkValidation={this.checkValidation}
                setRuleObject={this.setRuleObject}
                ruleObject={this.state.ruleObject}
                toggleModalVisibility={this.props.toggleModalVisibility} />;
        } else if (this.state.selectedRuleType === CQAppConstant.TRANSFER_RULE) {
            return <TransferRuleModal
                appliedRule={this.props.appliedRule}
                objectName={this.state.fieldData.fullName}
                referenceTo={this.state.fieldData.referenceTo}
                selectedFormulaType={this.getFormulaFieldType()}
                checkValidation={this.checkValidation}
                setRuleObject={this.setRuleObject}
                selectedTemplateName={this.props.selectedTemplateName}
                ruleObject={this.state.ruleObject}
                toggleModalVisibility={this.props.toggleModalVisibility} />;
        }
        else if (this.state.selectedRuleType.toLowerCase() === 'setvalues') {
            return <SetValuesRulesModal
                objectName={this.state.fieldData.fullName} appliedRule={this.props.appliedRule}
                checkValidation={this.checkValidation}
                setRuleObject={this.setRuleObject} selectedTemplateName={this.props.selectedTemplateName}
                toggleModalVisibility={this.props.toggleModalVisibility} ruleObject={this.state.ruleObject} />;
        }
        else if (this.state.selectedRuleType === 'invoke') {
            return <InvokeActionsRulesModal
                objectName={this.state.fieldData.fullName} appliedRule={this.props.appliedRule}
                checkValidation={this.checkValidation}
                setRuleObject={this.setRuleObject} selectedTemplateName={this.props.selectedTemplateName}
                toggleModalVisibility={this.props.toggleModalVisibility} ruleObject={this.state.ruleObject} />;
        }
        else if (this.state.selectedRuleType === 'onInit-invoke') {
            return <OnInitInvokeActionsRulesModal
                objectName={this.state.fieldData.fullName} appliedRule={this.props.appliedRule}
                checkValidation={this.checkValidation}
                setRuleObject={this.setRuleObject} selectedTemplateName={this.props.selectedTemplateName}
                toggleModalVisibility={this.props.toggleModalVisibility} ruleObject={this.state.ruleObject} />;
        }
        else if (this.state.selectedRuleType === 'onInit-setValues') {
            return <OnInitSetValuesActionsRulesModal
                objectName={this.state.fieldData.fullName} appliedRule={this.props.appliedRule}
                checkValidation={this.checkValidation}
                setRuleObject={this.setRuleObject} selectedTemplateName={this.props.selectedTemplateName}
                toggleModalVisibility={this.props.toggleModalVisibility} ruleObject={this.state.ruleObject} />;
        }
        else if (this.state.selectedRuleType === 'onLoad-setValues') {
            return <OnLoadSetValuesRulesModal
                objectName={this.state.fieldData.fullName} appliedRule={this.props.appliedRule}
                checkValidation={this.checkValidation}
                setRuleObject={this.setRuleObject} selectedTemplateName={this.props.selectedTemplateName}
                toggleModalVisibility={this.props.toggleModalVisibility} ruleObject={this.state.ruleObject} />;
        }
        else if (this.state.selectedRuleType === 'onLoad-invoke') {
            return <OnLoadInvokeRulesModal
                objectName={this.state.fieldData.fullName} appliedRule={this.props.appliedRule}
                checkValidation={this.checkValidation}
                setRuleObject={this.setRuleObject} selectedTemplateName={this.props.selectedTemplateName}
                toggleModalVisibility={this.props.toggleModalVisibility} ruleObject={this.state.ruleObject} />;
        }
        else if (this.state.selectedRuleType === 'onLoad-transfer') {
            return <OnLoadTransferRulesModal
                appliedRule={this.props.appliedRule}
                objectName={this.state.fieldData.fullName}
                checkValidation={this.checkValidation}
                setRuleObject={this.setRuleObject}
                selectedTemplateName={this.props.selectedTemplateName}
                ruleObject={this.state.ruleObject}
                toggleModalVisibility={this.props.toggleModalVisibility} />;
        }
        else if (this.state.selectedRuleType === 'afterSave-redirectTo') {
            return <AfterSaveRedirectToRulesModal
                ruleObject={this.state.ruleObject}
                setRuleObject={this.setRuleObject}
                appliedRule={this.props.appliedRule}
                checkValidation={this.checkValidation}
                objectName={this.state.fieldData.fullName}
                selectedTemplateName={this.props.selectedTemplateName}
                toggleModalVisibility={this.props.toggleModalVisibility} />;
        }
        return null;
    }

    /**
     * @private
     * @memberof ApplyRuleModalComponent
     */
    private formRuleJson = () => {
        switch (this.state.selectedRuleType) {
            case CQAppConstant.DYNAMIC_SOURCE:
                this.ruleEngineController.addDynamicSource(this.state.fieldData.fullName, this.state.selectedRuleType,
                    this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject), this.props.selectedTemplateName, this.props.toggleModalVisibility);
                break;
            case 'Formula Field - Hyperlink':
                this.ruleEngineController.addFormulaField(this.state.fieldData.fullName, this.state.selectedRuleType,
                    this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject), this.props.selectedTemplateName, this.props.toggleModalVisibility);
                break;
            case 'Formula Field - Image':
                this.ruleEngineController.addFormulaField(this.state.fieldData.fullName,
                    this.state.selectedRuleType,
                    this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject), this.props.selectedTemplateName, this.props.toggleModalVisibility);
                break;
            case 'lookupFilter':
                this.ruleEngineController.addLookupFilterField(this.state.fieldData.fullName, this.state.selectedRuleType,
                    this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject), this.props.selectedTemplateName, this.props.toggleModalVisibility);
                break;
            default:
                this.ruleEngineController.addInputRules(this.state.fieldData.fullName, this.state.selectedRuleType,
                    this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject),
                    this.props.selectedTemplateName,
                    this.props.toggleModalVisibility);
                break;
        }
    }

    /**
     * @private
     * @memberof ApplyRuleModalComponent
     */
    private previewInputRuleJSON = () => {
        switch (this.state.selectedRuleType) {
            case CQAppConstant.DYNAMIC_SOURCE:
                this.previewDynamicSource();
                break;
            default:
                this.previewInputRules();
                break;
        }
    }


    /**
     * @private
     * @memberof ApplyRuleModalComponent
     */
    private previewInputRules = () => {
        const ruleObject: any = this.ruleEngineController.getRuleController(this.state.selectedRuleType, this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject));
        this.setState({ ruleJSON: JSON.stringify(ruleObject, undefined, 2) });
    }

    /**
     * @memberof ApplyRuleModalComponent
     */
    previewDynamicSource = () => {
        let ruleObject: any = this.ruleEngineController.getRuleController(this.state.selectedRuleType, this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject));
        const dynamicSourceObject = this.ruleEngineController.returnDynamicSourceObject(ruleObject);
        const lookupFilterObject = this.ruleEngineController.returnLookupFilterFieldObject(ruleObject);
        this.setState({ ruleJSON: JSON.stringify(dynamicSourceObject, undefined, 2) + '\n' + JSON.stringify(lookupFilterObject, undefined, 2) });
    }

    /**
     * @private
     * @memberof ApplyRuleModalComponent
     */
    private readonly getFormulaFieldType = () => {
        if (this.state.selectedRuleType === 'Formula Field - Hyperlink') {
            return 'Hyperlink';
        } else {
            return 'Image';
        }
    }

    // /**
    // * @private
    // * @memberof ApplyRuleModalComponent
    // */
    // private readonly updateAdditionalFields = (newFieldName: string, action: string, replaceFieldName?: string) => {
    //     let additionalFields: any = { ...this.state.additionalFields };
    //     const ruleType = this.state.selectedRuleType;
    //     const objectName = this.state.fieldData.fullName;
    //     const objectKeys = Object.keys(additionalFields);

    //     if (objectKeys.length === 0) {
    //         additionalFields[objectName] = { [ruleType]: [newFieldName] };
    //     } else {
    //         const objectKeyExist = objectKeys.some((objectKey: string) => objectKey === objectName);
    //         if (objectKeyExist) {
    //             const objectWiseRules = additionalFields[objectName];
    //             const ruleTypes = Object.keys(objectWiseRules);
    //             if (ruleTypes.length === 0) {
    //                 additionalFields = this.setAdditionalField(objectName, ruleType, newFieldName, action, replaceFieldName);
    //             } else {
    //                 const ruleKeyExist = ruleTypes.some((rule: string) => rule === ruleType);
    //                 if (ruleKeyExist) {
    //                     additionalFields = this.setAdditionalField(objectName, ruleType, newFieldName, action, replaceFieldName);
    //                 } else {
    //                     additionalFields[objectName][ruleType] = [newFieldName];
    //                 }
    //             }
    //         }
    //     }

    
    //     this.setState({ additionalFields });

    // }

    // private readonly setAdditionalField = (objectName: string, ruleType: string, newFieldName: string, action: string, replaceFieldName?: string) => {
    //     const additionalFields: any = { ...this.state.additionalFields };
    //     const fields: string[] = additionalFields[objectName][ruleType];

    //     if (action === CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.ADD) {
    //         fields.push(newFieldName);
    //         additionalFields[objectName][ruleType] = fields;
    //     } else if (action === CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.DELETE) {
    //         const fieldIndex = fields.indexOf(newFieldName);
    //         if (fieldIndex > -1) {
    //             fields.splice(fieldIndex, 1);
    //             additionalFields[objectName][ruleType] = fields;
    //         }
    //     } else if (action === CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.UPDATE && replaceFieldName) {
    //         const fieldIndx = fields.indexOf(replaceFieldName);
    //         if (fieldIndx > -1) {
    //             fields.splice(fieldIndx, 1);
    //         }
    //         fields.push(newFieldName);
    //     }
    //     return additionalFields;
    // }
}
export const ApplyRuleModal = observer(ApplyRuleModalComponent);
